import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";

const renderOptions = (options, currentTab) => {
  const optionsArray = [{ value: "all", label: "See all" }];
  if (currentTab === "keyNumbers") {
    options.map(o => {
      if (o.has_snapshot || o.has_wd_profile) {
        optionsArray.push({
          value: o.country_id,
          label: o.country_name
        });
      }
    });
  }
  if (currentTab === "tariffs") {
    options.map(o => {
      if (o.tariff_average_value !== null && o.tariffs.length !== 0) {
        optionsArray.push({
          value: o.country_id,
          label: o.country_name
        });
      }
    });
  }
  if (currentTab === "oda") {
    options.map(o => {
      if (o.oda_numbers.annual_total_disbursement.length !== 0) {
        optionsArray.push({
          value: o.country_id,
          label: o.country_name
        });
      }
    });
  }
  return optionsArray;
};

const Dropdown = ({ options, onChange, selected, currentTab }) => {
  const selectOptions = renderOptions(options, currentTab);

  return (
    <Select
      className="africa-country-select"
      classNamePrefix="Select"
      classNames={{ container: () => "Select__container" }}
      isClearable={false}
      onChange={e => onChange(e.value)}
      options={selectOptions}
      placeholder="Select country"
      value={selectOptions.find(o => o.value === selected) || null}
      isSearchable={false}
    />
  );
};

export default Dropdown;

Dropdown.propTypes = {
  currentTab: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({}).isRequired),
  onChange: PropTypes.func.isRequired,
  selected: PropTypes.string,
};
